import React from 'react';
import "./Products.css"

class CourseComponent extends React.Component{
    constructor(props){
      super(props);
  
      this.state = {
        courses:[]
      };
    }
  
    // http://localhost:45545/course
    componentDidMount(){
      console.log('Component did mount, fetching courses...');
      this.fetchCourses();
    }

    fetchCourses = () => {
      //fetch("https://webapicleancodeengineer.azurewebsites.net/course")
      fetch(`${process.env.REACT_APP_API_BASE}/course`)
        .then(res => {
          if (!res.ok) {
            throw new Error('Network response was not ok ' + res.statusText);
          }
          return res.json();
        })
        .then(
          result => {
            console.log('Courses fetched successfully:', result);
            this.setState({ courses: result });
          },
          error => {
            console.error('Error fetching courses:', error);
          }
        );
    }
  
render(){
  return(
    <div className='product-container'>
      <h2>Details of Courses</h2>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Location</th>
            <th>Date</th>
            <th>Source</th>
          </tr>
        </thead>
        <tbody>
        <tr key='Arrays in C# - Data Structure'>
              <td data-label="Name">Array Data Structure</td>
              <td data-label="Description"><a href='https://youtu.be/zccTxWyWBVs?si=whGi0KaaW0Jr4U7w' target='_blank' rel='noopener noreferrer'>Fundamentals of defining an <span className="keyword">array</span> data structure</a></td>
              <td data-label="Location">Youtube</td>
              {/*<td data-label="Date">{crs.Date}</td>*/}
              <td data-label="Date">Available</td>
              <td data-label="Source">
                <a 
                  href="https://github.com/CleanCodeEngineer/ArraysAndStrings" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  GitHub
                </a>
              </td>
        </tr>
        <tr key='Binary Trees in C# - Data Structure'>
              <td data-label="Name">Binary Tree Data Structure</td>
              <td data-label="Description"><a href='https://youtu.be/GezCC1AEpTA?si=_z2SJ-ohULKRCtuv' target='_blank' rel='noopener noreferrer'>How to create a <span className="keyword">binary tree</span></a></td>
              <td data-label="Location">Youtube</td>
              {/*<td data-label="Date">{crs.Date}</td>*/}
              <td data-label="Date">Available</td>
              <td data-label="Source">
                <a 
                  href="https://github.com/CleanCodeEngineer/TreesAndGraphs" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  GitHub
                </a>
              </td>
        </tr>
        <tr key='Linked List in C# - Data Structure'>
              <td data-label="Name">Linked List Data Structure</td>
              <td data-label="Description">
                 <a href="https://youtu.be/Ywn02L4JGiU?si=6kZk-8gtSjUgehW1" target="_blank" rel="noopener noreferrer">
                  mastering <span className="keyword">singly linked lists</span>
                </a>
              </td>
              <td data-label="Location">Youtube</td>
              {/*<td data-label="Date">{crs.Date}</td>*/}
              <td data-label="Date">Available</td>
              <td data-label="Source">
                <a 
                  href="https://github.com/CleanCodeEngineer/LinkedLists" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  GitHub
                </a>
              </td>
        </tr>
        <tr key='Stacks in C# - Data Structure'>
              <td data-label="Name">Stack Data Structure</td>
              <td data-label="Description"><a href='https://youtu.be/7mpAimaV9ro?si=-ik33rcuXyfL_XPi' target='_blank' rel='noopener noreferrer'>mastering <span className="keyword">stacks</span></a></td>
              <td data-label="Location">Youtube</td>
              {/*<td data-label="Date">{crs.Date}</td>*/}
              <td data-label="Date">Available</td>
              <td data-label="Source">
                <a 
                  href="https://github.com/CleanCodeEngineer/Stacks" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  GitHub
                </a>
              </td>
        </tr>
        <tr key='Queue in C# - Data Structure'>
              <td data-label="Name">Queue Data Structure</td>
              <td data-label="Description"><a href='https://youtu.be/rzWWunH0lCc?si=PcUX6mtLI98xgX-E' target='_blank' rel='noopener noreferrer'>Implementation of a generic <span className="keyword">queue</span> from scratch</a></td>
              <td data-label="Location">Youtube</td>
              {/*<td data-label="Date">{crs.Date}</td>*/}
              <td data-label="Date">Available</td>
              <td data-label="Source">
                <a 
                  href="https://github.com/CleanCodeEngineer/Queue" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  GitHub
                </a>
              </td>
        </tr>
        <tr key='Implementing a Priority Queue using Min-Heap in C# - Data Structure'>
              <td data-label="Name">Implementing a Priority Queue using Min-Heap Data Structure</td>
              <td data-label="Description"><a href='https://youtu.be/d927sjTEoB0?si=THTLOvxOALwSDo1r' target='_blank' rel='noopener noreferrer'>Using a <span className="keyword">min-heap</span> data structure to maintain the priority queue</a></td>
              <td data-label="Location">Youtube</td>
              {/*<td data-label="Date">{crs.Date}</td>*/}
              <td data-label="Date">Available</td>
              <td data-label="Source">
                <a 
                  href="https://github.com/CleanCodeEngineer/ArraysAndStrings/blob/master/ArraysAndStrings/PriorityQueue.cs" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  GitHub
                </a>
              </td>
        </tr>
        <tr key='Object Oriented Design for a Restaurant Reservation System in C# - Part 1'>
              <td data-label="Name">Object Oriented Design for a Restaurant Reservation System</td>
              <td data-label="Description"><a href='https://youtu.be/kwvtxzXvojU?si=hdL-bxqYo4gEuNBq' target='_blank' rel='noopener noreferrer'>Restaurant Reservation System <span className="keyword">(OOD)</span></a></td>
              <td data-label="Location">Youtube</td>
              {/*<td data-label="Date">{crs.Date}</td>*/}
              <td data-label="Date">Available</td>
              <td data-label="Source">
                <a 
                  href="https://github.com/CleanCodeEngineer/ObjectOrientedDesign" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  GitHub
                </a>
              </td>
        </tr>

          {this.state.courses.map(crs=>(
            <tr key={crs.Name}>
              <td data-label="Name">{crs.Name}</td>
              <td data-label="Description">{crs.Description}</td>
              <td data-label="Location">{crs.Location}</td>
              {/*<td data-label="Date">{crs.Date}</td>*/}
              <td data-label="Date">Coming Soon...</td>
              <td data-label="Source">N/A</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
      );
    }
  }
  
  export default CourseComponent;